<div
  class="container-doc d-flex align-items-center justify-content-center"
  role="button"
  [attr.tabindex]="processed() ? -1 : 0"
  [attr.aria-disabled]="processed()"
  [attr.aria-label]="documento().nomeDocumento + ': ' + (txtStatus() || txtDownload())"
  [class.disableInput]="processed()"
  [class.error]="withError()"
  [class.success]="concluido()"
  [class.analyzing]="analyzing()"
  (click)="openUploadModal()"
  (keydown.enter)="openUploadModal()"
  (keydown.space)="$event.preventDefault(); openUploadModal()"
>
  <div class="d-flex flex-row align-items-center justify-content-between">
    <label class="d-flex flex-column justify-content-start">
      {{ documento().nomeDocumento }}
      <span>{{ txtDownload() }}</span>
    </label>
    <!-- Em análise: relógio; concluído: check; sem envio ou com erro: adicionar arquivo, que vira check verde após incluir. -->
    @if (txtStatus()) {
      <span class="status-doc">
        {{ txtStatus() }}
        <i class="las" [class.la-clock]="analyzing()" [class.la-check-circle]="concluido()" aria-hidden="true"></i>
      </span>
    } @else if (addFile()) {
      <span class="arquivo-incluido">
        <img src="assets/images/check-simple.svg" alt="Arquivo incluído">
      </span>
    } @else {
      <i class="las la-plus-circle" aria-hidden="true"></i>
    }
    <!-- O botão já vira clique no Enter/Espaço; a tecla não sobe para o card, que abriria o modal. -->
    @if (removivel()) {
      <vivest-icon-button
        class="remover-doc"
        variant="outline"
        size="sm"
        icon="trash-2"
        [attr.aria-label]="'Remover ' + documento().nomeDocumento"
        (click)="removerEnviado($event)"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
      ></vivest-icon-button>
    }
  </div>
</div>

<!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
<vivest-modal
  #modal
  [hasIcon]="false"
  [open]="openModal()"
  (vivest-close)="closeModal()"
>
  <div slot="heading">
    <p>Documento a ser carregado:</p>
    <h4>{{ documento().nomeDocumento }}</h4>
  </div>
  <div slot="description">
    <div class="container align-items-center justify-content-center">
      <div class="justify-content-between content-upload d-flex justify-content-center flex-column ml-5 mr-5">
        <div class="d-flex justify-content-center align-items-center flex-column mb-40 gap-4">
          <div class="pl-12 pr-12 d-flex flex-column gap-4">
            <label
              class="file-upload d-flex align-items-center text-center flex-column"
              [class.file-upload--selecionado]="arquivoSelecionado()"
              [attr.for]="'formFile-' + documento().tipoDocumento"
            >
              <p>Toque aqui para carregar uma foto do documento solicitado</p>
              <div class="file-upload__arquivo d-flex align-items-center justify-content-center">
                @if (arquivoSelecionado()) {
                  <div class="selected d-flex flex-row align-items-center">
                    <span class="nameFile">{{ nomeArquivoSelecionado() }}</span>
                    <span class="removeFile" role="button" tabindex="0" (click)="removeFile($event)" (keydown.enter)="removeFile($event)">Remover</span>
                  </div>
                } @else {
                  <img src="assets/images/upload-icone.svg" alt="">
                }
              </div>
              <input
                #fileInput
                class="form-control"
                type="file"
                accept=".png,.jpg,.pdf,.jpeg"
                [attr.id]="'formFile-' + documento().tipoDocumento"
                [disabled]="!!arquivoSelecionado()"
                (change)="onFileSelected($event)"
              >
              @if (!arquivoSelecionado()) {
                <span class="message-span">
                  Você poderá usar a câmera do seu aparelho ou buscar na galeria/explorador de arquivos.
                  <br />
                  <br />
                  Formatos aceitos: .jpg / .jpeg / .png / .pdf
                  <br />
                  Tamanho máximo: {{ tamanhoMaximoMb() }} MB
                </span>
              }
              @if (erroArquivo()) {
                <span class="erro-arquivo" role="alert">{{ erroArquivo() }}</span>
              }
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Cancelar</vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" [disabled]="!arquivoSelecionado()" (click)="onSubmit()">Continuar</vivest-button>
</vivest-modal>
